export default __webpack_public_path__ + "static/the-differance-is-clear-video-en-c784ad28486f57e3722010cb4db529ea.mp4";